import React from 'react';
import ColumnaDivisionesPais from './pais/ColumnaDivisionesPais.js';
import ColumnaTorneo from './ColumnaTorneo.js';
import ColumnaTorneosDivision from './pais/ColumnaTorneosDivision.js';
import ColumnaTorneosTipo from './internacionales/ColumnaTorneosTipoInt.js';
import PrincipalDivisionPais from './pais/PrincipalDivisionPais.js';
import PrincipalPais from './pais/PrincipalPais.js';
import PrincipalTorneosInt from './internacionales/PrincipalTorneosInt.js';
import PrincipalTorneo from './torneo/PrincipalTorneo.js';
import styles from './CuerpoTorneos.module.css';

const CuerpoTorneos = (props) => {
  const datosElegidos = props.datosElegidos;

  console.log('CuerpoTorneos', datosElegidos);

  const onDatoElegido = (filtro, valor) => {
    props.onDatoElegido(filtro, valor);
  };

  let columna = '';
  if (datosElegidos.pais && !datosElegidos.division) {
    columna = <ColumnaDivisionesPais pais={datosElegidos.pais} onDatoElegido={onDatoElegido} />;
  } else if (datosElegidos.tipoTorneo && !datosElegidos.torneo) {
    columna = (
      <ColumnaTorneosTipo
        categoria={datosElegidos.categoria}
        tipoTorneo={datosElegidos.tipoTorneo}
        onDatoElegido={onDatoElegido}
      />
    );
  } else if (datosElegidos.division && !datosElegidos.torneo) {
    columna = (
      <ColumnaTorneosDivision
        pais={datosElegidos.pais}
        categoria={datosElegidos.categoria}
        division={datosElegidos.division}
        onDatoElegido={onDatoElegido}
      />
    );
  } else {
    columna = (
      <ColumnaTorneo
        torneo={datosElegidos.torneo}
        categoria={datosElegidos.categoria}
        onDatoElegido={onDatoElegido}
      />
    );
  }

  let principal = '';
  if (datosElegidos.torneo) {
    principal = <PrincipalTorneo datosElegidos={datosElegidos} />;
  } else {
    if (datosElegidos.pais) {
      principal = datosElegidos.division ? (
        <PrincipalDivisionPais datosElegidos={datosElegidos} />
      ) : (
        <PrincipalPais datosElegidos={datosElegidos} />
      );
    } else if (datosElegidos.tipoTorneo) {
      columna = null;
      principal = <PrincipalTorneosInt datosElegidos={datosElegidos} />;
    }
  }

  return (
    <div className={`${styles.cuerpo}`}>
      <div className={`${styles.barra_lateral}`}>{columna}</div>
      <div className={`${styles.area_principal}`}>{principal}</div>
    </div>
  );
};

export default CuerpoTorneos;
